export default "__VITE_ASSET__BvJ7oHa2__"